
export function getUrlParam(url, name) {
    try {
        let info = url.split('?')[1];
        let getInfo = new URLSearchParams('?' + info);
        return getInfo.get(name)
    }
    catch {
        return null;
    }

    // var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)') //构造一个含有目标参数的正则表达式对象
    // var r = url.search.substr(1).match(reg) //匹配目标参数
    // alert(1)
    // if (r != null) return unescape(r[2])
    // return null //返回参数值
}


export function isWeChatBrowser () {
    return window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}